<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Add a guarantee period to {{hspt.huis_code }}  {{hspt.hspt_nr}}</p>
    <v-form ref="addHpgp" v-model="addHpgpValid">
      <v-row no-gutters>
        <v-col cols="6" class="pa-2">
            <date_picker label="Arrival from"                                 
                          :date="hpgpFromDate"
                          :startDate="hpgpFromDate"
                          field="hpgpFromDate" 
                          hint="Only enter a date when the cost is not applicable for the whole year or ends at a certain date" 
                          icon="mdi-calendar-month-outline"
                          :manual="true" 
                          @updateData="updateData"/> 
        </v-col>
        <v-col cols="6" class="pa-2">
            <date_picker label="Arrival until"                                 
                          :date="hpgpUntilDate"
                          :startDate="hpgpFromDate"
                          field="hpgpUntilDate" 
                          hint="Only enter a date when the cost is not applicable for the whole year or ends at a certain date" 
                          icon="mdi-calendar-month-outline"
                          :manual="true" 
                          @updateData="updateData"/>                                      
        </v-col>
      </v-row>     
      <v-row no-gutters>
        <v-col cols="6" class="pt-2 pb-2 pr-2 pl-10">
          <input_amount label="" prefix="€" :amount="hpgpAmount" field="hpgpAmount" @updateData="updateData"/>
          <!-- <v-text-field v-model="hspt.hpgp_bedrag"></v-text-field> -->
        </v-col>  
      </v-row>  
      <div v-if="bError" class="mt-2 mb-2 ml-5 mr-5 pa-1 text-center" style="background-color: #FFC1C3; border: 1px solid red; border-radius: 5px;">{{ sError }}</div>
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHpgp" :disabled="!addHpgpValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import date_picker from '@/components/ui/date_picker.vue';
import input_amount from '@/components/huis/hspt/ui/input_amount.vue';
export default {
  data() { 
    return {
      dialog: false,
      showStep2: false,
      addHpgpValid: false,
      hspt_encrid: null,
      seiz_code: '',
      hpgpFromDate: null, 
      hpgpUntilDate: null,
      hpgpAmount: '0',
      bError: false,
      sError: '',
      hspt: {}
    }
  },
  components: {
    date_picker, input_amount
  },  
  methods: {
    open(hspt_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.hspt_encrid = hspt_encrid;
      this.hpgpFromDate=null
      this.hpgpUntilDate=null 
      this.hpgpAmount='0'
      this.$axios
        .post("ares/json/ares/huis/hspt/hpgp/getHsptToAddHpgp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsptToAddHpgp"
          },
          getHsptToAddHpgp: {
            hspt_encrid: hspt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hspt = res.data.getHsptToAddHpgp;
            deze.hspt_encrid = hspt_encrid;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateData(data){
      console.log('updateData', data);
      this.bError = false; this.sError = ''
      this[data.field] = data.value;
    },    
    addHpgp() { 
      this.$axios
        .post("ares/json/ares/huis/hspt/hpgp/addHpgp2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHpgp"
          },
          addHpgp: {
            hspt_encrid: this.hspt.hspt_encrid,
            hpgp_van_dat: this.hpgpFromDate,
            hpgp_tm_dat: this.hpgpUntilDate,
            hpgp_bedrag: this.hpgpAmount
          }
        })
        .then(res => {
          if (res.data.error) {
            this.bError=true
            this.sError=res.data.error.message
          }  else {
             this.$emit("updateData")
             this.dialog = false;
          }
        })
    }
  }
}
</script>

